module.exports = __webpack_public_path__ + "static/media/tabulacao-sucesso.0765cf81.svg";